import { useTranslate } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, AlertTitle, Button } from '@mui/material';

import type { ReconciliationFreeze } from 'src/pages/admin/services/vaultService';
import { PermissionButton } from 'src/routes/components/permission-button';
import { paths } from 'src/routes/paths';

import { RECONCILIATION_PERMISSION_RESOURCE } from '../reconciliation/constants';
import { VAULTS_NS as NS } from './constants';
import { formatInstant } from './helpers';

/**
 * XBIT-4864: "this vault is frozen by reconciliation", with the way to Reconciliation & freezes (the reconciliation page).
 * Shown only for a freeze the BFF reports; it is not the closure-notice freeze (`closure.freezeAt`), which ClosureBlock shows.
 */
export const FrozenBanner = ({
  freeze,
  vaultId,
}: {
  freeze: ReconciliationFreeze | null;
  vaultId: string;
}) => {
  const translate = useTranslate();
  if (!freeze?.frozen) return null;
  const t = (key: string, options?: object) =>
    translate(`${NS}.detail.reconciliationFreeze.${key}`, options);
  const details = [
    freeze.frozenAt && t('since', { at: formatInstant(freeze.frozenAt) }),
    freeze.reason && t('reason', { reason: freeze.reason }),
  ].filter(Boolean);
  return (
    <Alert
      severity="warning"
      action={
        <PermissionButton resource={RECONCILIATION_PERMISSION_RESOURCE} action="read">
          <Button
            color="inherit"
            size="small"
            component={RouterLink}
            to={`${paths.dashboard.vaultReconciliation.root}?vault=${encodeURIComponent(vaultId)}`}
          >
            {t('open')}
          </Button>
        </PermissionButton>
      }
    >
      <AlertTitle>{t('title')}</AlertTitle>
      {[t('body'), ...details].join(' · ')}
    </Alert>
  );
};
